import essApi from "../axios/essApi";
import moment from "moment";
import jsPDF from 'jspdf';

async function convertImageToPDF(imageFile) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(imageFile);

        img.onload = () => {
            const pdf = new jsPDF();
            const imgWidth = pdf.internal.pageSize.getWidth();
            const imgHeight = (img.height * imgWidth) / img.width;

            pdf.addImage(img, 'JPEG', 0, 0, imgWidth, imgHeight);
            resolve(pdf.output('blob'));
        };

        img.onerror = (error) => {
            console.error('Error loading image:', error);
            reject(error);
        };
    });
}
class ExpenseService {
    async getCategories() {
        return Promise.resolve(essApi.get('expenseCategory/getall'))
    }

    async getAllLegalEntities() {
        return Promise.resolve(essApi.get('legal-entity'))
    }

    async uploadFiles(files) {
        try {
            let formData = new FormData();

            for (const file of files) {

                if (file.type.startsWith('image/')) {
                    const pdfBlob = await convertImageToPDF(file);
                    const pdfFile = new File([pdfBlob], `${file.name}.pdf`, { type: 'application/pdf' });
                    formData.append('files[]', pdfFile);
                } else {
                    formData.append('files[]', file);
                }
            }

            const requestConfig = {
                headers: { 'Content-Type': 'multipart/form-data' },
            };

            const response = await essApi.post('uploadFile', formData, requestConfig);

            return Promise.resolve(response);
        } catch (error) {
            console.error('Error uploading files:', error);
            return Promise.reject(error);
        }
    }


    async downloadFiles(param) {
        return Promise.resolve(essApi.get(`download/${param.url}`))
    }

    async createExpense(param) {
        return Promise.resolve(essApi.post('expenses/create', param))
    }

    async getExpenseClaimByUserId(param) {
        return Promise.resolve(essApi.get(`expenses/${param.status}`));
    }

    async getExpenseCategoryById(param) {
        return Promise.resolve(essApi.get(`expenseCategory/getbyid/${param}`))
    }

    async uploadexpense(param) {
        return Promise.resolve(essApi.post('uploadExpense', param))
    }

    async updateExpenseClaim(param) {
        return Promise.resolve(essApi.put(`/expenses/update/${param.claimId}`, param))
    }

    async updateDraftExpense(param) {
        return Promise.resolve(essApi.put(`/expenses/update`, param))
    }

    async getAllUsersBySuperiorId() {
        return Promise.resolve(essApi.get('/expense/userBySuperior'))
    }

    async getClaimActivities(claimId) {
        return Promise.resolve(essApi.get(`expensesTimeline/${claimId}`));
    }

    async getAllUsers(param) {
        if (Object.keys(param).length === 0) {
            return Promise.resolve(essApi.get(`expense/manager/getUserClaims`))
        } else {
            if (param.userId && param.fromDate && param.toDate) {
                let startDate = moment(moment(param.fromDate, 'DD-MM-YYYY')).format('YYYY-MM-DD')
                let endDate = moment(moment(param.toDate, 'DD-MM-YYYY')).format('YYYY-MM-DD')
                return Promise.resolve(essApi.get(`expense/manager/getUserClaims?startDate=${startDate}&endDate=${endDate}&userId=${param.userId}`))
            } else if (param.fromDate && param.toDate) {
                let startDate = moment(moment(param.fromDate, 'DD-MM-YYYY')).format('YYYY-MM-DD')
                let endDate = moment(moment(param.toDate, 'DD-MM-YYYY')).format('YYYY-MM-DD')
                return Promise.resolve(essApi.get(`expense/manager/getUserClaims?startDate=${startDate}&endDate=${endDate}`))
            } else {
                return Promise.resolve(essApi.get(`expense/manager/getUserClaims?userId=${param.userId}`))
            }
        }
    }

    async getAllCategoryByManager(param) {
        if (Object.keys(param).length > 0) {
            const startDate = moment(moment(param.fromDate, 'DD-MM-YYYY')).format('YYYY-MM-DD');
            const endDate = moment(moment(param.toDate, 'DD-MM-YYYY')).format('YYYY-MM-DD');
            return Promise.resolve(essApi.get(`/expense/categorymanager/getUserClaims?startDate=${startDate}&endDate=${endDate}`));
        } else {
            return Promise.resolve(essApi.get(`/expense/categorymanager/getUserClaims`));
        }
    }

    async deleteMultipleExpenseRecords(param) {
        return Promise.resolve(essApi.put(`/delete-multiple-expenses`, param))
    }

    async getFinanceData(param) {
        return Promise.resolve(essApi.post(`expense/manager/getFinanceExpenseClaims`, param))
    }

    async filterFinanceData(param) {
        return Promise.resolve(essApi.post(`/finance/team-filter`, param));
    }
    async getApprovers() {
        return Promise.resolve(essApi.get('/expense/approverRole'));
    }

    async getTeamClaimAmountProjectWise(date) {
        const year = parseInt(date.split('-')[0]);
        const startDate = year + "-" + "04-01"
        const endDate = year + 1 + "-" + "03-31"
        return Promise.resolve(essApi.get(`/expense/chart/project?startDate=${startDate}&endDate=${endDate}`));
    }

    async getTeamClaimAmountUserWise(date) {
        const year = parseInt(date.split('-')[0]);
        const startDate = year + "-" + "04-01"
        const endDate = year + 1 + "-" + "03-31"
        return Promise.resolve(essApi.get(`/expense/chart/team?startDate=${startDate}&endDate=${endDate}`));
    }
    async getCategoryWiseClaim(date) {
        const year = parseInt(date.split('-')[0]);
        const startDate = year + "-" + "04-01"
        const endDate = year + 1 + "-" + "03-31"
        return Promise.resolve(essApi.get(`/expense/chart/category?startDate=${startDate}&endDate=${endDate}`));
    }
}

export default ExpenseService;